var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organism-template-history',{attrs:{"template-detail":_vm.escalationTemplateDetail,"fields":_vm.fields,"items":_vm.escalationTemplateHistory,"filter-list":_vm.filterData}})}
var staticRenderFns = []

export { render, staticRenderFns }